import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";

// Stripe logout function is registered globally to avoid circular
// dependencies with src/shared/services/stripe/*.
let stripeLogoutFn = null;

export const registerStripeLogout = (logoutFn) => {
  stripeLogoutFn = logoutFn;
};

const invalidateSession = () => {
  // Auth tokens now live entirely inside MSAL's cache; the
  // sessionStorage clear performed by AuthenticationFailureHandler.logout
  // takes care of any other transient state we set during the session.
};

const invalidateSessionAndRedirect = async () => {
  if (stripeLogoutFn) {
    try {
      await stripeLogoutFn();
    } catch (error) {
      console.warn("Error during Stripe logout:", error);
    }
  }

  invalidateSession();
  try {
    window.close();
  } catch (error) {
    // Ignore window close errors
  }
  AuthenticationFailureHandler.logout();
};

export { invalidateSession, invalidateSessionAndRedirect };
